import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AssetService } from '../../services/asset-service';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
    selector: 'asset-lov',
    templateUrl: './asset-lov.component.html',
    styleUrls: ['./asset-lov.component.scss']
})

export class AssetLovComponent extends GenericLovComponent {

  assets      : Asset[] = [];
  barCode     : string;
  serialNumber: string;

  partner             : Partner      = new Partner();
  partnerLovComponent = PartnerLovComponent;
 
  columns = [
    {  prop: 'barCode',                       name: 'Code à Barres'},
    {  prop: 'assetCode',                     name: 'N° serie'},
    {  prop: 'assetProduct.assetProductCode', name: 'Ref. produit'},
  ]


  constructor(
    public dialogRef: MatDialogRef<AssetLovComponent>,
        protected assetService : AssetService,
        protected toastr: ToastrService,
        protected router: Router,
        protected location : Location) {
          super();
  }
      
 //----------------------------------------------------------------------------------------------------------------
  loadData() {
    let assetCode                 : string  = null;
    let withLinkedData            : boolean = false;
    let serialNumber              : string  = this.serialNumber;
    let barCode                   : string  = this.barCode;
    let assetOrderCode            : string  = null; 
    let branchCode                : string  = null;
    let assetProductCategoryCode  : string  = null;
    let assetProductCode          : string  = null;
    let  partnerCode              : string  = this.partner.partnerCode;
      this.assetService.assetsGet(
        assetCode            ,
        withLinkedData       ,
        serialNumber         ,
        barCode              ,
        assetOrderCode       , 
        branchCode           ,
        assetProductCategoryCode  ,
        assetProductCode          ,
        partnerCode          ).then(assets => {
        this.assets = assets;
    });
  }
 //----------------------------------------------------------------------------------------------------------------
  
 
 //----------------------------------------------------------------------------------------------------------------
  closeModal(asset : Asset){
    this.dialogRef.close(asset);
  }
 //----------------------------------------------------------------------------------------------------------------
  
}
